import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoaders } from '../../selectors';
import { linkWithParams } from '../../routes';
import { apTabChanged } from '../../actions/internal';
import { updateAccountPlayers } from '../../actions/partner';
import AccountPlayersTable from '../../components/accountplayers/AccountPlayersTable';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getLoaders(state, [
      'ACCOUNT_PLAYERS_FILTER',
      'ACCOUNT_PLAYERS',
    ]),
    meta: state.meta.accountPlayers,
    accountPlayers: state.accountPlayers,
    options: state.options.apColumns,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAccountPlayer: (id, tab) => {
      const path = {pathname: linkWithParams('accountPlayer', {id})};
      dispatch(apTabChanged(tab));
      dispatch(push(path));
    },
    onPageChange: (page) => {
      dispatch(updateAccountPlayers({page}))
    },
    onSortChange: (sort, order) => {
      dispatch(updateAccountPlayers({sort, order}))
    },
  }
}

const AccountPlayersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountPlayersTable)

export default AccountPlayersContainer;
